import { Menu, X, Radio } from "lucide-react";
import { Link, NavLink } from "react-router-dom";
import { useEffect, useState } from "react";

const nav = [
  { to: "/diagnosis", label: "料金診断" },
  { to: "/compare", label: "通信会社を比較" },
  { to: "/bill-check", label: "請求書チェック" },
  { to: "/articles", label: "記事" },
  { to: "/about", label: "この案内所について" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 w-full bg-background-100 border-b ${
        scrolled ? "border-background-200" : "border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1200px] px-4 md:px-6 h-[68px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 cursor-pointer" aria-label="スマホ代見直し案内所 ホーム">
          <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-white">
            <Radio size={20} aria-hidden="true" />
          </div>
          <div className="leading-tight">
            <div className="text-[15px] font-bold text-foreground-900">スマホ代見直し案内所</div>
            <div className="text-[11px] text-foreground-500 hidden sm:block">通信費をやさしく整理</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-medium rounded-md cursor-pointer whitespace-nowrap ${
                  isActive ? "text-primary-500" : "text-foreground-700 hover:text-primary-500"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
          <Link
            to="/diagnosis"
            className="ml-2 px-4 py-2 text-sm font-semibold rounded-md bg-primary-500 text-white hover:bg-primary-600 cursor-pointer whitespace-nowrap"
          >
            料金診断をする
          </Link>
        </nav>

        <button
          onClick={() => setOpen(!open)}
          onKeyDown={(event) => { if (event.key === "Escape") setOpen(false); }}
          className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 cursor-pointer"
          aria-label={open ? "メニューを閉じる" : "メニューを開く"}
          aria-expanded={open}
          aria-controls="mobile-navigation"
        >
          {open ? <X size={24} aria-hidden="true" /> : <Menu size={24} aria-hidden="true" />}
        </button>
      </div>

      {open && (
        <div id="mobile-navigation" className="lg:hidden border-t border-background-200 bg-background-50">
          <div className="px-4 py-3 flex flex-col">
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className="py-3 text-sm text-foreground-800 border-b border-background-100 cursor-pointer"
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/diagnosis"
              onClick={() => setOpen(false)}
              className="mt-3 py-3 text-center text-sm font-semibold rounded-md bg-primary-500 text-white cursor-pointer whitespace-nowrap"
            >
              自分に合う選択肢を診断する
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}